module.exports = __webpack_public_path__ + "static/media/icon_approve.749e5015.svg";